import React from 'react';
import styles from './Testimonials.module.css';
import { useScrollAnimation, useStaggerAnimation } from '../hooks/useScrollAnimation';

const TESTIMONIALS = [
  {
    stars: 5,
    quote:
      'We launched on r/SaaS and r/startups and went from zero traction to 400+ upvotes on our announcement post. The comments felt real — because they were written properly. Our sign-ups doubled that week.',
    name: 'Alex K.',
    role: 'Founder, B2B SaaS',
    initials: 'AK',
    avatarColor: 'rgba(59,130,246,0.15)',
    avatarText: '#60a5fa',
  },
  {
    stars: 5,
    quote:
      'I run campaigns for 6 clients and the Agency plan saves me hours every week. The white-label reports look professional and my clients are happy. The drip delivery is the real deal — nothing ever gets flagged.',
    name: 'Maria R.',
    role: 'Digital Marketing Agency Owner',
    initials: 'MR',
    avatarColor: 'rgba(34,197,94,0.1)',
    avatarText: '#22c55e',
  },
  {
    stars: 5,
    quote:
      'Started with the Trust Karma package so I could post in r/entrepreneur. Within 3 weeks I had 1,800 karma and my posts weren\'t getting filtered anymore. Worth every dollar — it unlocked everything else.',
    name: 'James S.',
    role: 'E-commerce Brand Owner',
    initials: 'JS',
    avatarColor: 'rgba(255,69,0,0.12)',
    avatarText: '#ff6534',
  },
];

export default function Testimonials() {
  const headRef = useScrollAnimation();
  const gridRef = useStaggerAnimation();

  return (
    <section className={styles.section}>
      <div className="container">
        <div className={`${styles.head} fade-up`} ref={headRef}>
          <div className="section-label">Results</div>
          <h2 className="section-title">Real clients, real traction.</h2>
          <p className="section-sub" style={{ margin: '0 auto', textAlign: 'center' }}>
            Businesses using GrowthBurrow to grow their presence and drive traffic.
          </p>
        </div>

        <div className={styles.grid} ref={gridRef}>
          {TESTIMONIALS.map((t) => (
            <div key={t.name} className={`${styles.card} stagger-child`}>
              <div className={styles.stars}>
                {'⭐'.repeat(t.stars)}
              </div>
              <p className={styles.quote}>"{t.quote}"</p>
              <div className={styles.author}>
                <div
                  className={styles.avatar}
                  style={{ background: t.avatarColor, color: t.avatarText }}
                >
                  {t.initials}
                </div>
                <div>
                  <div className={styles.name}>{t.name}</div>
                  <div className={styles.role}>{t.role}</div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
